var map = {
	"./charging/figurative_charging.svg": 7059,
	"./charging/figurative_free.svg": 5719,
	"./charging/figurative_unknown.svg": 2889,
	"./charging/figurative_used.svg": 7967,
	"./charging/figurative_waiting.svg": 6468,
	"./evoove_figurative_punch.svg": 7502,
	"./evoove_figurative_white.svg": 5654,
	"./evoove_white_withText.svg": 5237,
	"./evoove_white_withoutText.svg": 9274,
	"./icons/_menu_accounting.svg": 3803,
	"./icons/_menu_charging.svg": 323,
	"./icons/_menu_settings.svg": 2696,
	"./icons/arrow-left-s-line.svg": 953,
	"./icons/arrow-right-circle.svg": 7453,
	"./icons/arrow-right-line.svg": 8951,
	"./icons/arrow-right-s-line.svg": 1067,
	"./icons/battery.svg": 4513,
	"./icons/building-line.svg": 7640,
	"./icons/calendar.svg": 1421,
	"./icons/charging.svg": 6193,
	"./icons/clock.svg": 9212,
	"./icons/close-line.svg": 9660,
	"./icons/contacts-line.svg": 761,
	"./icons/dashboard-line.svg": 4266,
	"./icons/delete-bin-7-line.svg": 6445,
	"./icons/download-2-line.svg": 8595,
	"./icons/file-copy-line.svg": 9851,
	"./icons/flash.svg": 9669,
	"./icons/info.svg": 9932,
	"./icons/information-line.svg": 9071,
	"./icons/line-chart-line.svg": 4855,
	"./icons/logout.svg": 230,
	"./icons/mail-send-line.svg": 7870,
	"./icons/money-euro-circle-line.svg": 9715,
	"./icons/money.svg": 8835,
	"./icons/pencil-line.svg": 4655,
	"./icons/search-line.svg": 6650,
	"./icons/settings-2-line.svg": 1613,
	"./icons/settings-4-line.svg": 7348,
	"./icons/timer.svg": 4819,
	"./icons/user-3-line.svg": 2871,
	"./icons/user-shared-line.svg": 7472,
	"./icons/wallet-line.svg": 2885,
	"./icons/warning.svg": 5561,
	"./loading_circle.svg": 2922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7234;